import React, { useState } from "react";
import { StyledVideoLink } from "../_components/styled/styles.js";
import YoutubeEmbed from "../_components/common/YoutubeEmbed";
import { FaVideo } from "react-icons/fa";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  Icon,
  IconButton,
  Text,
  Link,
  Button,
} from "@chakra-ui/react";
import { FaPlay } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const TldrVideoInAction = ({
  title,
  videoInAction,
  showPlayIcon,
  color = "brand.primary",
  variant,
}) => {
  const { t } = useTranslation(["ai"]);
  const [show, setShow] = useState(false);
  return (
    <>
      {showPlayIcon ? (
        <IconButton
          bg="blackAlpha.700"
          icon={<Icon fontSize="1.6rem" as={FaPlay} />}
          size="lg"
          height="4rem"
          width="4rem"
          isRound
          onClick={() => setShow(true)}
        />
      ) : (
        <>
          {variant ? (
            <Button
              leftIcon={<FaVideo />}
              color={color}
              onClick={() => setShow(true)}
              data-toggle="modal"
              variant={variant}
            >
              {t("view_Action")}
            </Button>
          ) : (
            <Link 
            _hover={{textDecoration:"none"}}
            color={color}
            onClick={() => setShow(true)}
            data-toggle="modal"
            href="#view-in-action"
            ><Icon as={FaVideo} mr={1.5}/> {t("view_Action")}</Link>
          )}
        </>
      )}

      <Modal size="3xl" isCentered isOpen={show} onClose={() => setShow(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />

          <ModalBody p="0">
            <YoutubeEmbed
              embedId={videoInAction}
              title={title}
              width="100%"
              height="500px"
            ></YoutubeEmbed>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TldrVideoInAction;
